import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';


const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Production builds contain prerendered HTML for public pages. MUI components
// generate browser-only IDs, so hydrating a browser-generated snapshot would
// create ID mismatches. Keep the HTML in the response for crawlers/first paint,
// then mount the interactive application cleanly in the browser.
if (container.hasChildNodes()) {
  container.replaceChildren();
}
ReactDOM.createRoot(container).render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
